// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "flightCard__airline-ZeuJF";
var _4 = "flightCard__airlineLogo-J2RmN";
var _5 = "flightCard__airlineNumber-3IOA0";
var _6 = "flightCard__flightBlock-3JTxk";
var _7 = "flightCard__flightTitle-2TQZ-";
var _8 = "flightCard__flightValue-aRJ1s";
var _9 = "flightCard__footer-6-1FQ";
var _a = "flightCard__aircraftNameActive-1ak84";
var _b = "flightCard__info-3NUBr";
var _c = "aircraft_return-14rj8";
var _d = "aircraft__image-3rkkL";
export { _1 as "__esModule", _2 as "mobile", _3 as "flightCard__airline", _4 as "flightCard__airlineLogo", _5 as "flightCard__airlineNumber", _6 as "flightCard__flightBlock", _7 as "flightCard__flightTitle", _8 as "flightCard__flightValue", _9 as "flightCard__footer", _a as "flightCard__aircraftNameActive", _b as "flightCard__info", _c as "aircraft_return", _d as "aircraft__image" }
export default { "__esModule": _1, "mobile": _2, "flightCard__airline": _3, "flightCard__airlineLogo": _4, "flightCard__airlineNumber": _5, "flightCard__flightBlock": _6, "flightCard__flightTitle": _7, "flightCard__flightValue": _8, "flightCard__footer": _9, "flightCard__aircraftNameActive": _a, "flightCard__info": _b, "aircraft_return": _c, "aircraft__image": _d }
